@@ -0,0 +1,457 @@
<template>
    <div id="datatable">
        <form
            class="form-inline pull-right"
            v-if="$route.name !== 'ItemBank'"
            @submit.prevent="doFilter()"
        >
            <div class="form-group m-r-10" v-if="filterCriteria.length > 0">
                <span
                    class="label label-info m-r-5"
                    v-for="(criteria, index) in filterCriteria"
                    v-bind:key="index"
                    >{{ criteria }}</span
                >
            </div>
            <div class="form-group m-r-10">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Kata kunci"
                    v-model="query"
                    required
                />
            </div>
            <div class="form-group m-r-10">
                <select class="form-control" v-model="field" required>
                    <option
                        v-for="(value, key) in headers"
                        :value="key"
                        v-bind:key="key"
                    >
                        {{ value }}
                    </option>
                </select>
            </div>
            <div class="form-group m-r-10">
                <button type="submit" class="btn btn-white">Filter</button>
            </div>
            <div class="form-group m-r-10">
                <button
                    type="button"
                    class="btn btn-white"
                    @click="clearFilter()"
                >
                    Hapus Filter
                </button>
            </div>
            <div class="form-group m-r-10">
                <select
                    class="form-control"
                    v-model="orderBy"
                    v-on:change="updateOrderBy"
                >
                    <option value="desc">Baru ke Lama</option>
                    <option value="asc">Lama ke Baru</option>
                </select>
            </div>
        </form>

        <table class="table table-hover">
            <thead>
                <tr>
                    <th v-if="!$attrs.hidenumber">No.</th>
                    <th v-for="(header, index) in headers" v-bind:key="index">
                        {{ header }}
                    </th>
                    <th v-if="hasAction || hasExport">Action</th>
                    <th v-if="hasPaymentStatus">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(values, key) in currentPageItems"
                    @dblclick="selectRowAndFinish(key)"
                    @click="selectRow(key)"
                    v-bind:class="{ success: selectedRow == key }"
                    v-bind:key="key"
                >
                    <td v-if="!$attrs.hidenumber">
                        {{ startNumber + key + 1 }}
                    </td>
                    <td
                        v-for="(value, index) in values.data"
                        v-bind:key="index"
                    >
                        <span v-html="value">{{ index }}</span>
                    </td>
                    <td v-if="hasPaymentStatus">
                        <div
                            v-for="(values, index) in values.status"
                            v-bind:key="index"
                        >
                            <span
                                class="label"
                                :class="{
                                    'label-warning': values === 'CHECKOUT',
                                    'label-primary': values === 'CONFIRMED',
                                    'label-danger':
                                        values === 'EXPIRED' ||
                                        values === 'REJECTED',
                                    'label-success': values === 'ACTIVATED',
                                    'label-default': values === 'REFUND',
                                }"
                                style="font-size: 0.9em"
                                >{{ values }}</span
                            >
                        </div>
                    </td>
                    <td
                        v-if="hasExport"
                        style="
                            display: flex;
                            flex-flow: row;
                            justify-content: flex-start;
                            align-items: baseline;
                        "
                    >
                        <button
                            class="btn btn-primary btn-xs btn-edit m-1"
                            @click="exportItem(key)"
                        >
                            Export
                        </button>
                    </td>
                    <td
                        v-if="hasAction"
                        style="
                            display: flex;
                            flex-flow: row;
                            justify-content: flex-start;
                            align-items: baseline;
                        "
                    >
                        <button
                            v-if="hasEdit"
                            class="btn btn-primary btn-xs btn-edit m-1"
                            @click="editItem(key)"
                        >
                            Edit
                        </button>
                        <button
                            class="btn btn-danger btn-xs m-1"
                            @click="deleteItem(key)"
                        >
                            Hapus
                        </button>
                        <button
                            v-if="hasPreview"
                            class="btn btn-primary btn-xs btn-preview m-1"
                            data-toggle="modal"
                            data-target=".bd-example-modal-sm"
                            @click="previewVideo(values)"
                        >
                            Preview
                        </button>
                        <button
                            v-if="hasPublish && values.status === 'DRAFT'"
                            class="btn btn-success btn-xs btn-preview m-1"
                            @click="publishing(values)"
                        >
                            Publish
                        </button>
                        <button
                            v-if="hasPublish && values.status === 'PUBLISHED'"
                            class="btn btn-danger btn-xs btn-preview m-1"
                            @click="unpublishing(values)"
                        >
                            Unpublish
                        </button>
                        <div
                            class="modal fade bd-example-modal-sm"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="mySmallModalLabel"
                            aria-hidden="true"
                        >
                            <div class="modal-dialog modal-sm">
                                <div class="modal-content"></div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="$route.name !== 'ItemBank'">
            <div class="btn-group pull-left">
                <button class="btn btn-white" type="button">Total Page:</button>
                <button class="btn btn-white" type="button">
                    {{ this.maxPage }}
                </button>
            </div>
            <div class="btn-group pull-right" v-if="items.length > 0">
                <button
                    class="btn btn-white"
                    type="button"
                    v-on:click="goToPage(currentPage - 1)"
                >
                    Previous
                </button>
                <input
                    type="number"
                    v-model="currentPage"
                    min="1"
                    :max="maxPage"
                />
                <button
                    class="btn btn-white"
                    type="button"
                    v-on:click="goToPage(currentPage + 1)"
                >
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.btn-edit {
    margin-bottom: 5px;
}
.btn-preview {
    margin-top: 5px;
}
</style>

<script>
export default {
    name: "datatable",

    props: {
        items: { type: Array, default: [] },
        headers: { type: Array, default: [] },
        hasAction: { type: Boolean, default: true },
        hasExport: { type: Boolean, default: false },
        hasPreview: { type: Boolean, default: false },
        hasPublish: { type: Boolean, default: false },
        hasPaymentStatus: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        hasCustomPagination: { type: Boolean, default: false },
        hasCustomSearch: { type: Boolean, default: false },
        hasEdit: { type: Boolean, default: false },
        persistFilter: { type: Boolean, default: true },
        currentPageProp: { type: Number, default: 1 },
        customPaginationCurrentPage: { type: Number, default: 1 },
        customPaginationPerPage: { type: Number, default: 0 },
        customPaginationTotalItems: { type: Number, default: 0 },
        customPaginationTotalPages: { type: Number, default: 0 },
        customPaginationSortMode: { type: String, default: "desc" },
    },

    data: function () {
        return {
            currentPageItems: [],
            selectedRow: -1,
            filteredItems: [],
            query: null,
            orderBy: "desc",
            field: 0,
            videoId: null,
        };
    },

    computed: {
        player() {
            return this.$refs.youtube.player;
        },

        currentPage: {
            get: function () {
                if (this.hasCustomPagination) {
                    return this.customPaginationCurrentPage;
                }

                return parseInt(this.$store.state.datatable.currentPage);
            },
            set: function (val) {
                if (this.hasCustomPagination) {
                    this.goToPage(val);
                } else {
                    this.$store.commit("datatable_currentPage", val);
                }
            },
        },

        pageStart: function () {
            return this.$store.state.datatable.pageStart;
        },

        pageSize: function () {
            return (
                this.customPaginationPerPage ||
                this.$store.state.datatable.pageSize
            );
        },

        pageEnd: function () {
            return this.$store.state.datatable.pageEnd;
        },

        maxPage: function () {
            return this.hasCustomPagination
                ? this.customPaginationTotalPages
                    ? this.customPaginationTotalPages
                    : Math.ceil(this.customPaginationTotalItems / this.pageSize)
                : Math.ceil(this.filteredItems.length / this.pageSize);
        },

        startNumber() {
            if (this.$route.name === "ItemBank") {
                return (this.currentPageProp - 1) * this.pageSize;
            } else {
                return (this.currentPage - 1) * this.pageSize;
            }
        },

        filterCriteria: function () {
            var result = [];
            var filters = [];
            if (this.persistFilter)
                filters = this.$store.state.datatable.filters;

            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                var criteria = this.headers[filter.key] + " = " + filter.value;
                result.push(criteria);
            }

            return result;
        },
    },

    methods: {
        updateOrderBy: function (e) {
            if (e.target) {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", e.target.value);
                else this.$store.commit("datatable_orderby", e.target.value);
            } else {
                if (this.hasCustomPagination)
                    this.$emit("changeSortMode", e.target.value);
                else this.$store.commit("datatable_orderby", e);
            }
        },

        goToPage: function (page) {
            if (page > 0 && page <= this.maxPage) {
                if (this.hasCustomPagination) this.$emit("changePage", page);
                else this.$store.commit("datatable_currentPage", page);
            } else if (page > this.maxPage && !this.loading) {
                alert("Data hanya sampai " + this.maxPage + " Halaman");
            }
        },

        publishing(item) {
            this.$emit("publishing", item);
        },

        unpublishing(item) {
            this.$emit("unpublishing", item);
        },

        getItemsInPage: function (page) {
            page = this.hasCustomPagination ? 1 : page;
            var start = (page - 1) * this.pageSize;
            var end = start + this.pageSize;

            if (end > this.filteredItems.length - 1) {
                return this.filteredItems.slice(start);
            }

            return this.filteredItems.slice(start, end);
        },

        deleteItem: function (index) {
            var realIndex = index + (this.currentPage - 1) * this.pageSize;
            var selectedRow = this.hasCustomPagination
                ? this.selectRow(index)
                : this.filteredItems[realIndex];
            this.$emit("deleted", selectedRow);
        },

        previewVideo: function (index) {
            if (index.url.indexOf("embed") > -1) {
                this.videoId = index.url.split("/")[4];
            } else {
                this.videoId = index.url.substring(index.url.indexOf("=") + 1);
            }
        },

        selectRow: function (index) {
            var realIndex = this.hasCustomPagination
                ? index
                : index + (this.currentPage - 1) * this.pageSize;
            this.selectedRow = index;

            var selectedRow = this.filteredItems[realIndex];
            this.$emit("selected", selectedRow);

            return selectedRow;
        },

        selectRowAndFinish(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("dblClicked", selectedRow);
        },

        exportItem(index) {
            var selectedRow = this.selectRow(index);
            this.$emit("exportClicked", selectedRow);
        },

        editItem(index) {
            var realIndex = index + (this.currentPage - 1) * this.pageSize;
            this.selectedRow = index;

            var selectedRow = this.filteredItems[realIndex];
            this.$emit("editNewTab", selectedRow);
        },

        doFilter: function () {
            if (this.field != null) {
                this.query = this.query !== null ? this.query.trim() : "";
                var criteria = { key: this.field, value: this.query };

                if (this.hasCustomSearch) {
                    this.goToPage(1);

                    this.$store.commit("datatable_push_filter", criteria);
                    this.$emit("doSearch", criteria);
                } else {
                    this.$store.commit("datatable_push_filters", criteria);
                    var filters = this.$store.state.datatable.filters;

                    for (var i = 0; i < filters.length; i++) {
                        var filter = filters[i];
                        this.doBasicFilter(filter);
                    }

                    this.query = null;
                    this.field = 0;
                }
            }
        },

        doBasicFilter: function (filter) {
            var result = this.filteredItems.filter(function (item) {
                if (!item.data[filter.key]) return false;

                var index = item.data[filter.key]
                    .toLowerCase()
                    .indexOf(filter.value.toLowerCase());
                return index > -1;
            });

            this.filteredItems = result;
        },

        clearFilter: function () {
            this.query = null;
            this.field = 0;
            this.filteredItems = this.items;
            this.$store.commit("datatable_pageStart", 1);
            this.$store.commit("datatable_pageEnd", 10);
            this.$store.commit("datatable_clear_filter");
            this.doOrder();

            if (this.hasCustomPagination)
                this.orderBy = this.customPaginationSortMode;
            else this.orderBy = this.$store.state.datatable.orderBy;
            if (!this.hasCustomSearch)
                this.$store.commit("datatable_clear_filters");
            if (this.hasCustomSearch) {
                this.goToPage(1);
                this.$emit("doSearch", { value: null, key: null });
            }
        },

        doOrder: function () {
            var tmp = this.filteredItems.slice(0);
            if (this.$store.state.datatable.orderBy == "asc") {
                tmp.sort(function (a, b) {
                    return a.id - b.id;
                });
            } else {
                tmp.sort(function (a, b) {
                    return b.id - a.id;
                });
            }

            this.filteredItems = tmp;
        },

        playVideo() {
            this.player.playVideo();
        },

        playing() {
            console.log("o/ we are watching!!!");
        },
    },

    watch: {
        currentPage: function (page) {
            this.currentPageItems = this.getItemsInPage(page);
        },

        loading: function () {
            if (!this.loading) {
                setTimeout(() => {
                    this.updateOrderBy(this.orderBy);
                    this.doOrder();
                }, 500);
            }
        },

        items: function (val) {
            this.filteredItems = val;
            var fullPath = this.$route.fullPath;
            var datatableContext = this.$store.state.datatable.context;
            if (fullPath == datatableContext) {
                var filters = this.$store.state.datatable.filter;
                for (var i = 0; i < filters.length; i++) {
                    var filter = filters[i];
                    this.doBasicFilter(filter);
                }
            } else {
                this.$store.commit("datatable_context", fullPath);
                this.clearFilter();
            }
        },

        filteredItems: function (val) {
            this.$store.commit("datatable_currentPage", 1);
            this.currentPageItems = this.getItemsInPage(this.currentPage);
        },

        orderBy: function (val) {
            this.$store.commit("datatable_orderby", val);
            this.doOrder();
        },
    },

    mounted: function () {
        this.filteredItems = this.items;
        this.currentPageItems = this.getItemsInPage(1);

        if (this.hasCustomPagination)
            this.orderBy = this.customPaginationSortMode;
        else this.orderBy = this.$store.state.datatable.orderBy;

        if (this.$store.state.datatable.filter != {}) {
            (this.query = this.$store.state.datatable.filter.value),
                (this.field = this.$store.state.datatable.filter.key);
        }
    },
};
</script>



// WEBPACK FOOTER //
// DataTable.vue?043d7098